import React, { FC, useEffect, useState } from 'react'
import { Card, Table } from 'antd'
import { resultsTableColumn } from '../Results'
import Icon from '../../components/Icon'
import { IResultDetail } from '../../types/results'
import { storageApi } from '../../api'
import RResultSummaryCard from '../../components/RResultSummaryCard'

const Home: FC = () => {
  const [results, setResults] = useState<IResultDetail[]>([])
  const [isLoadingResults, setIsLoadingResults] = useState(true)
  const [summaryResultId, setSummaryResultId] = useState<string>('')

  async function fetchResults() {
    try {
      setIsLoadingResults(true)
      const resultsResponse = await storageApi.fetchResults()

      setResults(resultsResponse)
      setSummaryResultId(resultsResponse[resultsResponse.length - 1]?.id)
      setIsLoadingResults(false)
    } catch {
      setResults([])
    }
  }

  useEffect(() => {
    fetchResults()
  }, [])

  return (
    <>
      {summaryResultId && <RResultSummaryCard resultId={summaryResultId} />}

      <Card
        title={
          <>
            <Icon icon='square-poll-horizontal' /> Results
          </>
        }
        className='mb-24 ticket-primary'
      >
        <Table
          size='small'
          rowClassName='cursor-pointer'
          columns={resultsTableColumn}
          dataSource={results.slice(0, results.length > 5 ? 5 : results.length)}
          loading={isLoadingResults}
          pagination={false}
        />
      </Card>
    </>
  )
}

export default Home
